module.exports = __webpack_public_path__ + "img/american-flag-icon.90f7b7b2.svg";